import entity from '../../../models/cms/courses'

export default [
  {
    path: '/courses',
    meta: {
      entity,
      requiresPermissionTo: 'courses',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'courses' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/courses/new',
    meta: {
      entity,
      requiresPermissionTo: 'courses',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'courses' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/courses/:id',
    meta: {
      entity,
      requiresPermissionTo: 'courses',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'courses' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
